// The real player search (Track 2, ids-3): app-api's `/player-search` as it is — fuzzy,
// 3+ letters, up to 15 players, ~3.5 s (track2-plan.md §8.4). A fast search is Track 3 (§8.6).

import { rememberFamiliarName } from "../data/familiar-names.js";
import { getPlayerShortName } from "../data/player-utils.js";
import type { PlayerSearchResponse } from "@catbento/shared";
import type { LiveApi } from "./api.js";
import type { PickedPlayer } from "./picked-players.js";

/** The API answers an empty list below this (its "keep typing" state); the picker says so
 *  instead of asking. */
export const MIN_SEARCH_LETTERS = 3;

/** One search → the players it found (id, name, latest team), in the API's order. */
export async function searchLivePlayers(api: LiveApi, query: string): Promise<PickedPlayer[]> {
  const { players } = await api.get<PlayerSearchResponse>(`/player-search?q=${encodeURIComponent(query)}`);
  // Each result's familiar name is learnt now, so the list already reads "Lionel Messi".
  for (const p of players) rememberFamiliarName(p.name, p.nickname);
  return players.map((p) => ({ id: p.id, name: p.name, team: p.team, nickname: p.nickname }));
}

/** A result row's text: name + team (fork 2B), so two players with one name — the two
 *  Sam Kerrs — can be told apart. */
export function searchRowText(p: PickedPlayer): string {
  const name = getPlayerShortName(p);
  return p.team ? `${name} — ${p.team}` : name;
}
